import { Box, Heading } from '@zillow/constellation-10';
import { IconPetsFilled } from '@zillow/constellation-icons';

import PetPolicyWizardTipContent from './components/PetPolicyWizardTipContent';

import {
  wizardFlexContainerStyles,
  wizardFormSectionContainerStyles,
  wizardHeadingStyles,
} from '../../../../styles/wizard';

import PetsAllowedFormField from '../../../PostingPath/PetsAllowedFormField';
import PageWizard from '../../../Wizard/PageWizard';
import WizardTipCardContainer from '../../../WizardTipCardContainer';

import type { WizardBodyTemplateProps } from '../../../WizardStepController';

const PetPolicyAndPetFee = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  showDesktopViewBreakpoint,
  ...rest
}: WizardBodyTemplateProps) => {
  return (
    <PageWizard
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onGoToNextStep || undefined}
      onBackClick={onGoToPrevStep || undefined}
      onExitTriggered={onExitWizard}
      showDesktopViewBreakpoint={showDesktopViewBreakpoint}
      {...rest}
    >
      <div data-testid="PetPolicyAndPetFee">
        <Box css={wizardFlexContainerStyles}>
          <Box data-testid="FormSectionContainer" css={wizardFormSectionContainerStyles.raw()}>
            <Heading textStyle="heading-sm" level={2} css={wizardHeadingStyles}>
              Tell us about your pet policy
            </Heading>

            <PetsAllowedFormField />
          </Box>

          <WizardTipCardContainer
            header="Renters love their pets"
            icon={<IconPetsFilled />}
            showDesktopViewBreakpoint={showDesktopViewBreakpoint}
          >
            <PetPolicyWizardTipContent />
          </WizardTipCardContainer>
        </Box>
      </div>
    </PageWizard>
  );
};

export default PetPolicyAndPetFee;
